import { onMount, onDestroy } from "svelte";
import { writable } from "svelte/store";
export const useRendered = () => {
    let rendered = writable(false);
    onMount(() => rendered.set(true));
    onDestroy(() => rendered.set(false));
    return { rendered };
};
export const useDebounce = (func, delay) => {
    let timeoutId;
    const debounce = (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(null, args);
        }, delay);
    };
    onMount(() => {
        return () => {
            clearTimeout(timeoutId);
        };
    });
    return debounce.bind(func);
};
